import React from "react";

/**
 * NO-Q Secondary Button
 * Built with "Urban Butler" persona: Efficient, Tactile, and Bold.
 */
const SecondaryButton = ({
    children,
    onClick,
    type = "button",
    disabled = false,
    className = "",
}) => {
    return (
        <button
            type={type}
            onClick={onClick}
            disabled={disabled}
            className={`inline-flex bg-white text-txt-main  items-center justify-center px-6 py-3 font-body font-bold text-base whitespace-nowrap
              border-border-color  rounded-noq-sm border-2 transition-all duration-200 ease-in-out
              hover:scale-[0.97]
              focus:outline-none focus:ring-2  focus:ring-offset-2
              disabled:opacity-50 disabled:cursor-not-allowed disabled:active:scale-100
              ${className}
            `}
        >
            {children}
        </button>
    );
};

export default SecondaryButton;
